const SchoolCalendarIcon = (props) => {
    return (
        <svg
            width={80}
            height={80}
            viewBox="0 0 100 100"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M42 23c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM29 23c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM16 15c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM68 23c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM55 23c2.2 0 4-1.8 4-4s-1.8-4-4-4-4 1.8-4 4 1.8 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
                fill="#fff"
            />
            <path
                d="M80 39V16c0-2.8-2.2-5-5-5H9c-2.8 0-5 2.2-5 5v68c0 2.8 2.2 5 5 5h61c14.3 0 26-11.7 26-26 0-10.8-6.6-20.1-16-24zm-10-2c-2.8 0-5.5.4-8 1.3V27h16v11.3c-2.5-.9-5.2-1.3-8-1.3zM24 72V58h17v14H24zm17 2v13H24V74h17zm0-47v13H24V27h17zM24 42h17v14H24V42zm-2 14H6V42h16v14zm0-16H6V27h16v13zM6 58h16v14H6V58zm37 0h1.5c-.3 1.6-.5 3.3-.5 5 0 3.2.6 6.2 1.6 9H43V58zm2-2h-2V42h11.7c-4.7 3.4-8.1 8.3-9.7 14zm12.9-16H43V27h17v12c-.7.3-1.4.6-2.1 1zM6 16c0-1.7 1.3-3 3-3h66c1.7 0 3 1.3 3 3v9H6v-9zm0 68V74h16v13H9c-1.7 0-3-1.3-3-3zm37 3V74h3.4C49.2 79.8 54 84.5 60 87H43zm27 0c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24z"
                fill="#fff"
            />
            <path
                d="M70 43c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20zm1 37.9V79c0-.6-.4-1-1-1s-1 .4-1 1v1.9c-9.1-.5-16.4-7.8-16.9-16.9H54c.6 0 1-.4 1-1s-.4-1-1-1h-1.9c.5-9.1 7.8-16.4 16.9-16.9V47c0 .6.4 1 1 1s1-.4 1-1v-1.9c9.1.5 16.4 7.8 16.9 16.9H86c-.6 0-1 .4-1 1s.4 1 1 1h1.9c-.5 9.1-7.8 16.4-16.9 16.9zM38.7 44.3c-.4-.4-1-.4-1.4 0l-7.1 7.1-2.3-3.9c-.3-.5-.9-.6-1.4-.3-.5.3-.6.9-.3 1.4l3 5c.2.3.4.4.7.5h.1c.3 0 .5-.1.7-.3l8-8c.4-.5.4-1.1 0-1.5z"
                fill="#fff"
            />
            <path
                d="M83 62h-9.1c-.4-1.4-1.5-2.5-2.9-2.9V53c0-.6-.4-1-1-1s-1 .4-1 1v6.1c-1.7.4-3 2-3 3.9 0 2.2 1.8 4 4 4 1.9 0 3.4-1.3 3.9-3H83c.6 0 1-.4 1-1s-.4-1-1-1zm-13 3c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
                fill="#fff"
            />
        </svg>
    )
}

export default SchoolCalendarIcon